"use client";

import { useState } from "react";
import { Play } from "lucide-react";

interface VideoEmbedProps {
  src: string;
  title: string;
}

export function VideoEmbed({ src, title }: VideoEmbedProps) {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="relative w-full overflow-hidden rounded-xl" style={{ paddingBottom: "56.25%" }}>
        <iframe
          src={src}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          className="absolute inset-0 h-full w-full"
        />
      </div>
    );
  }

  return (
    <div className="flex justify-center">
      <button
        onClick={() => setPlaying(true)}
        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-cb-violet hover:bg-cb-violet-dim text-white text-sm font-semibold transition-colors cursor-pointer"
      >
        <Play className="h-4 w-4 fill-white" />
        Watch video
      </button>
    </div>
  );
}
